<template>
  <CCard class="c-signature-input">
    <Vue3Signature ref="signature" :h="height + 'px'" @mouseup="save" @touchend="save"/>
    <CButton theme="normal-primary" @click="clear" class="c-signature-input-clear">
      <CIcon name="remove"/>
      {{ $t('signature.clear') }}
    </CButton>
  </CCard>
</template>

<script setup lang="ts">
  import Vue3Signature from 'vue3-signature';
  import { Base64Image } from '../../models/common';
  import { componentRef } from '../../utils/component';
  import CCard from '../CCard.vue';
  import CIcon from '../CIcon.vue';
  import CButton from '../buttons/CButton.vue';

  const props = withDefaults(defineProps<{
    height?: number,
    format?: string,
  }>(), {
    height: 430,
    format: 'image/jpeg',
  });

  const emit = defineEmits<{
    (e: 'update:value', value: Base64Image | null),
  }>();

  const signature = componentRef<Vue3Signature>();

  function save() {
    emit('update:value', signature.value.save(props.format));
  }

  function clear() {
    signature.value.clear();
    emit('update:value', null);
  }
</script>

<style lang="scss">
  .c-signature-input {
    position: relative;

    &-clear {
      position: absolute;
      right: 1rem;
      top: 1rem;
    }
  }
</style>